import axios from 'axios';

class publicApi {
  constructor() {
    this.axios = axios.create({
      baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
      headers: {
        'Content-type': 'application/json',
      },
    });
  }

  get = (url) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.axios.get(url);
        resolve(response.data);
      } catch (err) {
        console.log('Public API Service : get error', err);
        reject(err);
      }
    });
  };

  post = (url, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.axios.post(url, payload);
        resolve(response.data);
      } catch (err) {
        console.log('Public API Service : post error', err);
        reject(err);
      }
    });
  };
}

export default new publicApi();
